import { Flex, Input } from "antd";
import React from "react";
import { ZUid } from "src/types/zUid";

type PropsIdInfo = {
  dataNode: {
    id: ZUid | null | undefined;
    displayId?: ZUid | null | undefined;
  };
};
export const IdInfo: React.FC<PropsIdInfo> = ({
  dataNode: { displayId, id },
}) => (
  <Flex gap={8}>
    <Input disabled addonBefore="UUID" value={id ?? ""} />
    <Input disabled addonBefore="Display ID" value={displayId ?? ""} />
  </Flex>
);
